import { map, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../shared/services/api-service/api-service';
import { Observable, of, asyncScheduler } from 'rxjs';

export interface ITileData {
  tile: string;
  tile_order: number;
  tile_type: string;
  description: string;
  category: string;
  category_order: number;
  to_focus_key: string;
  grouping_to_apply: string;
  filters_to_apply: string;
  ems: boolean;
  hs: boolean;
  hst: boolean;
  top: number;
  bottom: number;
}

/* istanbul ignore next */
@Injectable()
export class NetDashTileDataService {
  private tileCache;

  constructor(private apiService: ApiService) {}

  getNetDashTileData$(): Observable<Array<ITileData>> {
    if (!this.tileCache) {
      return this.apiService.getStudentsGraphQL(this.getNetDashTileQuery()).pipe(
        map(({ data: { NetworkDashTiles } }) => NetworkDashTiles),
        tap(tileData => (this.tileCache = tileData)),
      );
    } else return of(this.tileCache, asyncScheduler);
  }

  private getNetDashTileQuery() {
    const query = `{
      NetworkDashTiles {
        category
        category_order
        description
        tile
        tile_order
        filters_to_apply
        tile_type
        to_focus_key
        grouping_to_apply
        ems
        hs
        hst
        top
        bottom
      }
    }`;
    return { query, fetchPolicy: 'no-cache' };
  }
}
